/**
 * Inventory Store
 *
 * @since 2018-08-28
 * @author Nanhyoung.Ro <dev014>
 */
import compareObject from '~/utils/compare'
export const state = () => ({
  apiPreFix: '/api/lr',
  settingApi: '/monitor/log-manager',
  backupApi: '/servers',
  commandApi: '/command/log-manager',
  // ===  onSearch ===
  search: {
  },
  rmBakList: [],
  defaultInfo: {}, // 로그 관리 설정 조회 시 초기값
  backupList: [],
  defaultList: [],
  logDistDefaultList: [],
  distList: []
})

export const actions = {
  // 로그 관리 설정 조회
  async getSearchResult ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})
      if (result.code === 'ok') {
        state.defaultInfo = result.result
      } else {
        state.defaultInfo = {}
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.defaultInfo = {}
      return result
    }
  },
  async setLogSettings ({commit, state}, updateList) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}`
    try {
      result = await this.$axios.$put(apiUrl, updateList, {loading: true, successAlert: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },

  // 로그 백업 서버 조회
  async getbakSvrResult ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}${state.backupApi}`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})
      if (result.code === 'ok') {
        state.defaultList = result.result
      } else {
        state.defaultList = []
      }

      state.backupList = _.cloneDeep(state.defaultList)
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.defaultList = []
      state.backupList = []
      return result
    }
  },
  // 로그 백업 서버 추가
  async addBakSvrResult ({commit, state, dispatch}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}${state.backupApi}`
    try {
      result = await this.$axios.$post(apiUrl, param)
      if (result.code === 'ok') {
        // state.backupList.push(result.result)
        dispatch('getbakSvrResult')
      }

      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 로그 백업 서버 수정
  async editBakSvrResult ({commit, state, dispatch}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}${state.backupApi}/${param.param.log_backup_server_id}`
    try {
      result = await this.$axios.$put(apiUrl, param.param, {successAlert: false})

      if (result.code === 'ok') {
        await dispatch('getbakSvrResult')
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 로그 백업 서버 수정 (일괄)
  async editBakSvrAllResult ({commit, state}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}${state.backupApi}`
    try {
      result = await this.$axios.$put(apiUrl, { items: param }, {successAlert: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 로그 백업 서버 삭제
  async removeBakSvrResult ({commit, state}, svrId) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}${state.backupApi}/${svrId}`
    try {
      result = await this.$axios.$delete(apiUrl)
      if (result.code === 'ok') {
        const findIdx = _.findIndex(state.backupList, (d) => {
          return d.log_backup_server_id === svrId
        })
        state.backupList.splice(findIdx, 1)

        if (_.findIndex(state.rmBakList, (id) => { return id === svrId }) < 0) {
          state.rmBakList.push(svrId)
        }
      }

      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.defaultList = []
      return result
    }
  },

  // 로그 백업 서버 결과 조회
  async getBakSvrResResult ({commit, state}, svrId) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}${state.backupApi}/${svrId}/infos`
    try {
      result = await this.$axios.$get(apiUrl)
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },

  // 로그 분산 저장 설정 조회
  async getDisSaveList ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}/monitoring/log-manager/dist_config`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})
      if (result.code === 'ok') {
        state.logDistDefaultList = result.result.list
      } else {
        state.logDistDefaultList = []
      }
      state.distList = _.cloneDeep(state.logDistDefaultList)
      state.distList.forEach((item, index) => {
        item.no = index + 1
      })
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },

  // 로그 분산 저장 설정 조회
  async useDisSaveList ({commit, state}, useYn) {
    let result = {}
    const apiUrl = `${state.apiPreFix}/monitoring/log-manager/dist_config`
    try {
      const params = []
      state.distList.forEach(items => {
        params.push({
          device_id: items.device_id,
          log_dist_yn: items.log_dist_yn
        })
      })
      result = await this.$axios.post(apiUrl, {list: params, log_distribute_use_yn: useYn}, {successAlert: false})

      return result.data
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },

  async applySettings ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.commandApi}/apply`
    try {
      result = await this.$axios.$put(apiUrl, {clear_history: state.rmBakList}, {applyMsg: true})
      if (result.code === 'ok') {
        state.rmBakList = []
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.settingsInfo = {}
      return result
    }
  },

  async cancelSettings ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.commandApi}/cancel`
    try {
      result = await this.$axios.$put(apiUrl, null, {cancelMsg: true})
      if (result.code === 'ok') {
        state.rmBakList = []
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.settingsInfo = {}
      return result
    }
  }
}

export const getters = {
  compareBackupList (state) {
    const chgDatas = _.cloneDeep(state.backupList)
    _.forEach(chgDatas, (d) => {
      delete d.itemIndex
      delete d.isBtnView
    })
    return compareObject(state.defaultList, chgDatas)
  }
}
export const strict = false
